import * as React from 'react';

import store from '/var/lib/jenkins/workspace/ggsc-prod-dy-cjyx-web/src/pages/Home/store';

import PageComponent from '/var/lib/jenkins/workspace/ggsc-prod-dy-cjyx-web/src/pages/Home';

const PageComponentName = PageComponent;

const PageProvider = store.Provider;
const StoreWrapperedPage = (props) => {
  return (
    <PageProvider>
      <PageComponentName {...props} />
    </PageProvider>
  );
};
(StoreWrapperedPage as any).pageConfig =
  (PageComponentName as any).pageConfig || ({} as any);
(StoreWrapperedPage as any).getInitialProps = (
  PageComponentName as any
).getInitialProps;
export default StoreWrapperedPage;
export { store };
